import React from 'react';
import { Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import landingRoutes from './landing/views/routes';
import systemRoutes from './system/views/routes';

const Routes = () => {
  return (
    <ReactRoutes>
      {landingRoutes.map((item, i) => (
        <Route key={i} path={item.path} element={item.renderer()} />
      ))}
      {systemRoutes.map((item, i) => (
        <Route key={i} path={item.path} element={item.renderer()} />
      ))}
      <Route path="*" element={<Navigate replace to="/not-found-cover" />} />
    </ReactRoutes>
  );
};

export default Routes;
